import { __decorate } from "tslib";
import BranchesFilter from "@/components/BranchesFilter.vue";
import Doughnut from '@/components/Charts/Doughnut.vue';
import DateFilter from '@/components/DateFilter.vue';
import mobileFiltersModal from "@/components/mobileFiltersModal.vue";
import Money from '@/components/Money.vue';
import SimpleTable from '@/components/SimpleTable.vue';
import Tags from "@/components/Tags.vue";
import TeamFilter from '@/components/TeamFilter.vue';
import ModalMixin from "@/mixins/modal-mixin";
import BirthDateFilter from "@/Pages/People/BirthDateFilter.vue";
import LastVisitFilter from "@/Pages/People/LastVisitFilter.vue";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { mapActions, mapGetters, mapState } from 'vuex';
import CustomerModal from './CustomerModal.vue';
let CustomersComponent = class CustomersComponent extends Mixins(ModalMixin) {
    currentPageCustomersIds = [];
    sort = 'createdAt';
    order = -1;
    query = null;
    tagsQuery = [];
    branchesId = [];
    user = [];
    gender = [];
    dates = {};
    birthDateQ = {};
    lastVisitQ = {};
    currentPage = 1;
    perPage = 10;
    archived = 0;
    totalRows = 0;
    drafts = 0;
    totalCustomers = 0;
    debtors = 0;
    prepaid = 0;
    genderChart = [];
    fetchCustomers;
    removeCustomer;
    findCustomersInStore;
    getTag;
    areCustomersLoading;
    customerDefaults = {
        avatar_id: '',
        avatar: undefined,
        gender: 'female',
        allow_general_sms: true,
        allow_promo_sms: true
    };
    get customers() {
        return this.findCustomersInStore({
            query: {
                _id: {
                    $in: this.currentPageCustomersIds,
                },
                $sort: {
                    [this.sort]: this.order
                },
            }
        }).data;
    }
    get filter() {
        return this.$route.params.filter;
    }
    get columns() {
        const columns = [
            {
                label: '',
                name: 'status',
                width: 1,
                field: (item) => {
                    if (item.blacklisted)
                        return `<span v-b-tooltip title="Blacklisted"  class="fe fe-alert-triangle text-warning" ></span>`;
                    let a = [];
                    if (item.tags && item.tags.length > 0) {
                        let tags = item.tags.map(tag => {
                            let tagItem = this.getTag(tag);
                            if (!tagItem)
                                return;
                            return '<span class="mr-2  m-0 p-0  h1  text-' + tagItem.color + '">•</span>';
                        });
                        a.push(tags.join(''));
                    }
                    return a.join('<br >');
                }
            },
            {
                label: 'Image',
                name: 'preview',
                image: true,
                width: 50,
                link: (item) => {
                    return {
                        name: 'people.customer',
                        params: { id: item._id }
                    };
                },
                field: (item) => {
                    if (item.avatar) {
                        return item.avatar.preview;
                    }
                }
            },
            {
                label: 'Name',
                name: 'first_name',
                sortable: true,
                link: (item) => {
                    return {
                        name: 'people.customer',
                        params: { id: item._id }
                    };
                },
                subtitle: (item) => {
                    let a = [item.phone, item.email];
                    return a.join('<br >');
                },
                field: (item) => {
                    let field = [item.first_name, item.last_name, item.middle_name];
                    return field.join(' ');
                }
            },
            {
                label: 'Discount',
                name: 'discountPercent',
                sortable: true,
                field(item) {
                    return ((item.discountPercent) ? item.discountPercent : 0) + ' <span class="small text-muted">%</span>';
                }
            },
            {
                label: 'Balance',
                name: 'balance',
                sortable: true,
                money: (item) => {
                    return item.balance;
                },
                subtitle: (item) => {
                    if (item.debtReturn && item.debtReturn.date) {
                        let message = ` <div>  ${this.$moment(item.debtReturn.date).format('DD MMM dddd, YYYY')} </div>`;
                        if (item.debtReturn.text)
                            message += `<i class="fe fe-message-square"></i> ${item.debtReturn.text}`;
                        return message;
                    }
                },
            },
            {
                label: 'Gender',
                name: 'gender',
                sortable: true,
                field: (item) => {
                    if (!item.gender)
                        return '';
                    return this.$t(item.gender);
                }
            },
            {
                label: 'Age',
                name: 'birth_date',
                sortable: true,
                field: (item) => {
                    if (item.birth_date) {
                        let age = this.$moment().diff(item.birth_date, 'years');
                        return age || 0;
                    }
                    else
                        return '-';
                }
            },
            {
                label: 'Date',
                name: 'createdAt',
                sortable: true,
                duration: true,
            },
            {
                label: 'Last visit',
                name: 'lastVisit',
                sortable: true,
                duration: true
            }
        ];
        if (!this.$loadModule('billing')) {
            columns.splice(3, 2); // remove discount and balance columns
        }
        return columns;
    }
    get fetchParams() {
        const params = {
            query: {
                draft: { $ne: true },
                $limit: this.perPage,
                $skip: (this.currentPage - 1) * this.perPage,
                $sort: {
                    [this.sort]: this.order
                }
            }
        };
        if (!params.query)
            params.query = {};
        if (this.tagsQuery.length > 0) {
            params.query.tags = { $in: this.tagsQuery };
        }
        if (this.branchesId.length > 0) {
            // @ts-ignore
            params.query.branchesId = this.branchesId;
        }
        if (this.query) {
            Object.assign(params.query, this.$customersSearch(this.query));
        }
        if (this.user.length > 0) {
            params.query.userId = { $in: this.user };
        }
        if (this.gender.length > 0) {
            params.query.gender = { $in: this.gender };
        }
        if (this.dates.start && this.dates.end) {
            params.query.createdAt = {
                $gte: this.dates.start,
                $lte: this.dates.end
            };
        }
        Object.assign(params.query, this.birthDateQ, this.lastVisitQ);
        if (this.filter) {
            switch (this.filter) {
                case 'debtors':
                    params.query.balance = { $lt: 0 };
                    break;
                case 'prepaid':
                    params.query.balance = { $gt: 0 };
                    break;
                case 'archived':
                    params.query.deleted = true;
                    break;
                case 'drafts':
                    params.query.draft = true;
                    break;
                case 'upcoming':
                    params.query['debtReturn.date'] = {
                        $gte: this.$moment().format(),
                        $lte: this.$moment().endOf('month').format(),
                    };
                    break;
                case 'outdated':
                    params.query['debtReturn.date'] = {
                        $lte: this.$moment().format(),
                    };
                    break;
            }
        }
        return params;
    }
    mounted() {
        this.findCustomers();
        this.$root.$on('32desk::customer::created', this.findCustomers);
    }
    unmounted() {
        this.$root.$off('32desk::customer::created', this.findCustomers);
    }
    findCustomers() {
        this.fetchCustomers(this.fetchParams).then((data) => {
            this.genderChart = data.meta;
            this.archived = data.archived;
            this.totalCustomers = data.totalCustomers;
            this.totalRows = data.total;
            this.debtors = data.debtors;
            this.prepaid = data.prepaid;
            this.drafts = data.drafts;
            this.currentPageCustomersIds = data.data.map((customer) => customer._id);
        });
    }
    openDatePicker() {
        const flatPickrInstance = this.$refs.datePickerWrap.fp;
        flatPickrInstance._positionElement = window.document.getElementById('appendHere'); // eslint-disable-line
        flatPickrInstance.open();
    }
    setSort(field, order) {
        this.sort = field;
        this.order = order;
    }
    clearDateRange() {
        this.dates = {};
    }
    edit(item) {
        this.openModal({
            id: 'customerFormModal',
            model: item
        });
    }
    deleteItem(item) {
        this.removeCustomer(item._id).then(() => {
            this.$toasted.global.success({
                message: 'Customer deleted'
            });
        });
    }
};
__decorate([
    Watch('fetchParams')
], CustomersComponent.prototype, "findCustomers", null);
CustomersComponent = __decorate([
    Component({
        components: {
            LastVisitFilter,
            BirthDateFilter,
            BranchesFilter,
            Doughnut,
            DateFilter,
            TeamFilter,
            SimpleTable,
            CustomerModal,
            Money,
            Tags,
            mobileFiltersModal,
        },
        computed: {
            ...mapState('customers', { areCustomersLoading: 'isFindPending' }),
            ...mapGetters('customers', { findCustomersInStore: 'find' }),
            ...mapGetters('tags', { getTag: 'get' }),
        },
        methods: {
            ...mapActions('customers', { fetchCustomers: 'find', removeCustomer: 'remove' }),
        }
    })
], CustomersComponent);
export default CustomersComponent;
